import { defineStore } from "pinia";

/**
 * Konversation, die im schwebenden Fenster angezeigt wird (Auszug aus der
 * MessageCenter-Konversationsliste; weitere Felder werden durchgereicht).
 */
export interface ConversationWindowConversation {
  id: number;
  idCase?: number | null;
  subject?: string;
  caseNumber?: string;
  participants?: Array<{
    idUser?: number | null;
    userName?: string;
    externalEmail?: string;
    externalName?: string;
  }>;
  [key: string]: unknown;
}

/**
 * App-globaler Zustand des schwebenden Unterhaltungs-Fensters (Kundenfeedback
 * 30.08.26): Das Fenster gehört nicht mehr dem MessageCenter, sondern der App
 * (gemountet in App.vue neben der MinimizedWindowDock). Dadurch überlebt es —
 * inklusive minimiertem Dock-Chip — jeden Seitenwechsel (z. B. Dokumente im
 * Fall) und bleibt offen, bis der Anwender es selbst schließt.
 */
export const useConversationWindowStore = defineStore("conversationWindow", {
  state: (): {
    isOpen: boolean;
    conversation: ConversationWindowConversation | null;
    /** Zähler: wird bei jedem gesendeten Reply erhöht (für Listen-Refresh). */
    sentTick: number;
  } => ({
    isOpen: false,
    conversation: null,
    sentTick: 0,
  }),

  actions: {
    /** Öffnet das Fenster für die übergebene Konversation. */
    open(conversation: ConversationWindowConversation) {
      this.conversation = conversation;
      this.isOpen = true;
    },

    /** Schließt das Fenster (z. B. X-Button oder Logout). */
    close() {
      this.isOpen = false;
      this.conversation = null;
    },

    /** Meldet einen erfolgreichen Versand (MessageCenter refresht darauf). */
    notifySent() {
      this.sentTick += 1;
    },
  },
});
